import React from 'react';
import styles from '../LayoutDetail.module.css';
import DeviceList from '../../DeviceList/DeviceList';

const DevicesTab = ({ 
    devices, 
    typeFilter, 
    selectedDevice, 
    onTypeFilterChange, 
    onDeviceSelect, 
    onDeviceEdit, 
    onDeviceDelete, 
    onUpdateDevice, 
    onAddDevice 
}) => {
    return (
        <div className={styles.tabContent}>
            <div className={styles.filterSection}>
                <div className={styles.filterGroup}>
                    <label className={styles.filterLabel}>Type:</label>
                    <div className={styles.filterButtons}>
                        <button 
                            className={`${styles.filterButton} ${typeFilter === 'all' ? styles.active : ''}`}
                            onClick={() => onTypeFilterChange('all')}
                        >
                            All
                        </button>
                        <button 
                            className={`${styles.filterButton} ${typeFilter === 'light' ? styles.active : ''}`}
                            onClick={() => onTypeFilterChange('light')}
                        >
                            Light
                        </button>
                        <button 
                            className={`${styles.filterButton} ${typeFilter === 'signal' ? styles.active : ''}`}
                            onClick={() => onTypeFilterChange('signal')}
                        >
                            Signal
                        </button>
                    </div>
                </div>
            </div>

            {devices && devices.length > 0 ? (
                <div className={styles.deviceListWrapper}>
                    <DeviceList 
                        devices={devices.filter(device => 
                            typeFilter === 'all' || device.type === typeFilter
                        )}
                        selectedDevice={selectedDevice}
                        onDeviceSelect={onDeviceSelect}
                        onDeviceEdit={onDeviceEdit}
                        showAddForm={false}
                        handleDelete={onDeviceDelete}
                        onUpdateDevice={onUpdateDevice}
                    />
                </div>
            ) : (
                <div className={styles.noDevices}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                        <line x1="8" y1="21" x2="16" y2="21"/>
                        <line x1="12" y1="17" x2="12" y2="21"/>
                    </svg>
                    <p>No devices in this layout</p>
                    <button className={styles.addFirstDevice} onClick={onAddDevice}>
                        Add First Device
                    </button>
                </div>
            )}
        </div>
    );
};

export default DevicesTab; 